import { IconRatingStar } from '@app/icons';
import { FC } from 'react';
import { cn } from 'lib/utils';

interface IRating {
  rating: number;
  reverse?: boolean;
  marginSize?: number;
}

const StarRating: FC<IRating> = ({
  rating = 0,
  reverse = false,
  marginSize,
}) => {
  const ratingArr = [1, 2, 3, 4, 5];
  return (
    <div
      className={cn(
        'flex items-center',
        reverse ? 'flex-row-reverse' : 'flex-row',
        marginSize ? '' : ''
      )}
    >
      <span
        className={cn(
          'text-sm font-medium text-muted-foreground ml-2',
          reverse ? 'order-2' : 'order-1'
        )}
        style={{ marginLeft: marginSize }}
      >
        {rating ? rating : 0} /5
      </span>
      <ul
        className={cn('flex gap-1 ml-2', reverse ? 'order-1' : 'order-2')}
        style={{ marginLeft: marginSize }}
      >
        {ratingArr.map((star, index) => (
          <li key={index}>
            <IconRatingStar
              className={cn(
                index + 1 <= rating
                  ? 'text-yellow-400'
                  : 'text-muted-foreground'
              )}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StarRating;
